import { useUserContext } from '@/context';
import { message } from 'antd';
import { useState } from 'react';
import { useFormik } from 'formik';
import { UserHttp } from '@/services';
import { UserValidation } from '@/validations';
import { useTranslation } from 'react-i18next';

export default function useChangePassword() {

  const [t] = useTranslation(['common']);
  const [loading, setLoading] = useState(false);
  const { profile } = useUserContext();
  // const userId = profile?.id;
  const saminKey = profile?.saminKey;

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      newPassword: '',
      newPasswordConfirm: ''
    },
    validationSchema: UserValidation.changePassword,
    onSubmit: async (values) => {
      setLoading(true);
      // await UserHttp.changePassword(userId, {
      //   saminKey,
      //   password: values.currentPassword,
      //   newPassword: values.newPassword,
      //   repeatNewPassword: values.newPasswordConfirm,
      // }).finally(() => setLoading(false));
      // message.success({ content: t('common:messages.success-password-change') });
      // formik.resetForm();
      await UserHttp.changeMePassword({
        saminKey,
        password: values.currentPassword,
        newPassword: values.newPassword,
        repeatNewPassword: values.newPasswordConfirm,
      }).finally(() => setLoading(false));
      message.success({ content: t('common:messages.success-password-change') });
      formik.resetForm();
    },
  });

  return { formik, loading };

}
